import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import { SplitDirection } from '@/modules/common/enums/split-direction.ts';

type FileWorkingType = 'edit' | 'review' | 'view';

interface State {
  fileWorkingType: FileWorkingType;
  isMenuOpen: boolean;
  split: Record<string, number>;
  splitDirection: SplitDirection;
}

/* Не синхронизируется между вкладками */
export const useSystemStore = defineStore(StoreId.System, {
  state: (): State => ({
    fileWorkingType: 'edit', // В pinia для persistent
    isMenuOpen: false, // В pinia для persistent
    split: {}, // В pinia для persistent
    splitDirection: SplitDirection.Horizontal,
  }),
  getters: {
    getSplit: (state) => (key: string) => state.split[key],
  },
  actions: {
    setSplit(key: string, value: number) {
      this.split[key] = value;
    },
    setSplitDirection(direction: SplitDirection) {
      this.splitDirection = direction;
    },
    openMenu() {
      this.isMenuOpen = true;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
  persist: true,
});
